import React from 'react'
import SwipeableViews from 'react-swipeable-views'
import { autoPlay } from 'react-swipeable-views-utils'
import styled, { css } from 'styled-components'
import { range } from '@raysync/common/utils'
import { transition } from '@raysync/common/theme'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews)
const SwiperContainer = styled.div`
  position: relative;
  width: 100%;
`

const TouchBarNavWrap = styled.div`
  ${({ theme: { color } }) => css`
    width: 100%;
    height: 0.08rem;
    position: relative;
    display: flex;
    border-radius: 4px;
    z-index: 10;
    &::before {
      position: absolute;
      content: '';
      width: 1.725rem;
      height: 0.08rem;
      display: block;
      z-index: 10;
      background-color: ${color.secondary};
      border-radius: 4px;
      transform: ${p => `translateX(${p.activedIndex * 1.725}rem)`};
      transition: ${transition('transform')};
    }
  `}
`
const TouchBarNav = styled.span`
  display: inline-block;
  width: 25%;
  background-color: #e1e5eb;
  transition: ${transition('background-color')};
`
function TouchSwiper({ interval = 8000, children, barStyle }) {
  const [index, setIndex] = React.useState(0)
  return (
    <SwiperContainer>
      <TouchBarNavWrap activedIndex={index} style={barStyle}>
        {range(children.length).map(i => (
          <TouchBarNav key={i} active={i === index} onClick={() => setIndex(i)} />
        ))}
      </TouchBarNavWrap>
      <AutoPlaySwipeableViews
        index={index}
        interval={interval}
        enableMouseEvents
        onChangeIndex={index => setIndex(index)}
      >
        {children}
      </AutoPlaySwipeableViews>
    </SwiperContainer>
  )
}

export default TouchSwiper
